// File: src/MathTools/GenericGraphTool.js
//----------------------------------------------------------
import { useRef, useEffect } from "react";
import drawGrid from "./drawGrid"; // your existing grid-drawing function

export default function GenericGraphTool({
  equation = "x**2",
  displayEquation,
  widthCells = 10,
  heightCells = 10,
  cellSize = 30
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    // 1) 直接在 effect 裡宣告 f
    let f;
    try {
      const eq = equation.replace(/\^/g, "**");
      // eslint-disable-next-line no-new-func
      f = new Function("x", `return (${eq});`);
    } catch (err) {
      console.error("Failed to parse equation:", err);
      f = x => 0;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const W = widthCells * cellSize;
    const H = heightCells * cellSize;

    ctx.clearRect(0, 0, W, H);
    drawGrid(canvas, { widthCells, heightCells, cellSize, showAxes: false }, []);

    // Axes
    const midX = W/2, midY = H/2;
    ctx.strokeStyle = "#444";
    ctx.lineWidth   = 1;
    ctx.beginPath();
      ctx.moveTo(0,   midY);
      ctx.lineTo(W,   midY);
      ctx.moveTo(midX,0   );
      ctx.lineTo(midX,H   );
    ctx.stroke();

    // Plot the function
    ctx.beginPath();
    ctx.strokeStyle = "#d32f2f";
    ctx.lineWidth   = 2;

    for (let px = 0; px <= W; px++) {
      const xVal = (px - midX)/cellSize;
      let yVal;
      try {
        yVal = f(xVal);
      } catch (er) {
        yVal = 0; 
      }
      const py = midY - yVal*cellSize;
      if (px === 0) {
        ctx.moveTo(px, py);
      } else {
        ctx.lineTo(px, py);
      }
    }
    ctx.stroke();

  }, [equation, widthCells, heightCells, cellSize]);

  return (
    <div style={{ textAlign: "center" }}>
      <canvas
        ref={canvasRef}
        width={widthCells*cellSize}
        height={heightCells*cellSize}
        style={{ border: "1px solid #444" }}
      />
      <p style={{ fontFamily: "monospace", marginTop: 8 }}>
        <em>Plots y = {displayEquation}</em>
      </p>
    </div>
  );
}
